import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=677cec94&scoped=true"
import script from "./Mask.vue?vue&type=script&lang=js"
export * from "./Mask.vue?vue&type=script&lang=js"
import style0 from "./Mask.vue?vue&type=style&index=0&id=677cec94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677cec94",
  null
  
)

export default component.exports